
export default {
  name: 'ListingFooter',
  props: {
    filters: {
      type: Array,
    },
    categories: {
      type: Array,
    },
    seoData: {
      type: Object,
    },
    isSearchParams: {
      type: Boolean,
      default: false,
    },
    articles: {
      type: Array,
    },
    faq: {
      type: Array,
    },
    header: {
      type: String,
      default: 'bed',
    },
  },
};
